import useIsMobile from '@hooks/use-is-mobile';
import DesktopPDFViewer from './desktop-pdf-viewer';
import MobilePDFViewer from './mobile-pdf-viewer';

function PDFViewer() {
  const isMobile = useIsMobile();
  return isMobile ? <MobilePDFViewer /> : <DesktopPDFViewer />;
}

export default PDFViewer;
